import { TicketUser } from "@jugl-web/rest-api/tickets/models/common-types";

export const formatTicketUserName = (user: TicketUser): string =>
  [user.first_name, user.last_name].filter(Boolean).join(" ");
